import * as React from 'react';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import MESSAGES from 'src/app/Pages/Profile/Account-Profile/AccountProfile.messages';
import { Link } from 'react-router-dom';
import { ModalContainer } from 'src/app/Container/Modal/Modal';
import { ChangePasswordForm, ChangeEmailForm } from '../Authentification';
import { Dispatch } from 'redux';

export interface AccountSecurityProps {
  dispatch: Dispatch;
  location: GlobalPrivateState['router']['location'];
  modals: GlobalPrivateState['modals'];
  user: GlobalPrivateState['user'];
}

const modalId = 'profile-security';

export class AccountSecurityPartial extends React.Component<AccountSecurityProps> {
  public render() {
    return this.user ? (
      <>
        <div className="col-12 col-md-6 col-lg-6 login-data d-flex justify-content-center align-items-center flex-wrap pl-4">
          <div className="form-group-inner w-100 h-100">
            <div className="row">
              <div className="col-12">
                <div className="field">
                  <h6>
                    <FormattedMessage {...MESSAGES.accountProfileEmail} />
                  </h6>
                  <p className="m-0">{this.user.email}</p>
                </div>
              </div>
              <div className="col-12">
                <div className="field">
                  <h6>
                    <FormattedMessage {...MESSAGES.accountProfilePassword} />
                  </h6>
                  <p className="m-0">••••••••••</p>
                </div>
              </div>
            </div>
            <Link
              className="btn btn-secondary"
              to={`${this.props.location.pathname}?${modalId}=true`}
            >
              <FormattedMessage {...MESSAGES.accountProfileUserButton} />
            </Link>
          </div>
        </div>
        <ModalContainer
          byQuery={true}
          className="login-security-modal"
          id={modalId}
          showCloseBtn={true}
        >
          <div className="account-profile-modal d-flex justify-content-center align-items-center h-100">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <ChangePasswordForm />
                </div>
                <div className="col-12 col-lg-6">
                  <ChangeEmailForm />
                </div>
              </div>
            </div>
          </div>
        </ModalContainer>
      </>
    ) : null;
  }

  private get user(): GlobalPrivateState['user']['result'] | undefined {
    return this.props.user && this.props.user.result;
  }
}

export const AccountSecurity = connect((state: GlobalPrivateState) => ({
  location: state.router.location,
  modals: state.modals,
  user: state.user,
}))(AccountSecurityPartial);